import { Injectable } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  $loading = new Subject<boolean>();
  exclusiveLock: boolean = false;
  private active = true;
  requestCount: number = 0;
  
  isLoading: boolean = false;
  isPageLoading: boolean = false;
  hidingDelayTime: number = 300;
  hidingTimer: any;

  constructor(
    private router: Router,
  ){
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.showPageLoading()
      } else if (event instanceof RouteConfigLoadEnd) {
        this.hidePageLoading();
      }
    });
  }

  showPageLoading(){
    this.isPageLoading = true;
    this.show();
  }

  hidePageLoading(){
    this.isPageLoading = false;
    if(this.requestCount === 0){
      this.hide();
    }
  }

  show() {
    if(!this.active) return;

    if(this.hidingTimer){
      window.clearTimeout(this.hidingTimer);
      this.hidingTimer = null;
    }

    this.isLoading = true;
    this.$loading.next(true);
  }

  loading(): Observable<boolean>{
    return this.$loading.asObservable();
  }

  hide() {
    this.hidingTimer = setTimeout(() => {
      this.isLoading = false;
      this.$loading.next(false);
    }, this.hidingDelayTime);
  }

  showAndSetExclusiveLock(){
    this.exclusiveLock = true;
    this.show();    
  }
  
  hideAndrelaseExclusiveLock(){
    this.exclusiveLock = false;
    this.hide();
  }

  setActive(active: boolean){
    this.active = active;
    if(!this.active){
      this.hide();
    }
  }

  updateRequest(count: number){
    this.requestCount+= count;

    if(this.requestCount > 0){
      this.show();
    }
    else{
      this.hide();
    }
  }
}
